import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const factor = async (id?: number) => axios.get(Routes.FACTOR + "/" + id);

export const useFactor = (id?: number) =>
  useQuery({
    queryKey: [Keys.FACTOR_QRY, id],
    queryFn: () => factor(id),
    enabled: id ? true : false,
  });
